import { Component } from '@angular/core';
import { BaseComponent } from 'src/app/core/components/base-component/base-component.component';

@Component({
  selector: 'ui-title-bar',
  templateUrl: './title-bar.component.html',
  styleUrls: ['./title-bar.component.scss'],
  standalone: false,
})
export class TitleBarComponent extends BaseComponent {
  constructor() {
    super();
  }
}
